// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"4b608975","487":"cdae08b1","645":"91ad9733","933":"6a881f46"}[chunkId] + ".chunk.js";
};